export class ActionGetBlockchainStatus {
  static readonly type = '[ Blockchain ] get blockchain status';
  constructor() {}
}
